import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap5';

import CpaInfo from './CpaInfo';
import Steps from './Steps';
import CoachInfo from './CoachInfo';
import Actions from './Actions';

export default function Index({ program }) {
  const programId = `program-${program.id}`;
  const programStatus = program.attributes.status;
  const cpaProgram = program.attributes.program_type === 'cpa_only_program';
  const showAssignedLabel = cpaProgram || programStatus === 'assigned' || programStatus === 'saved_for_later';
  const aiProgram = program.attributes.program_category === 'ai';

  return (
    <div className="program-card d-flex flex-column h-100">
      <header className="mb-3">
        <div className="text-secondary">
          {program.attributes.state}
        </div>

        <h5>
          {program.attributes.title}
        </h5>
      </header>

      <Row className="h-100">
        {cpaProgram ? (
          <CpaInfo />
        ) : (
          <Steps programId={programId} program={program} />
        )}

        <Col md="6">
          <div className="info d-flex flex-column h-100">
            <div className="mb-2 text-end">
              {showAssignedLabel ? 'Assigned' : 'Started'}
              {' '}
              on
              {' '}
              {program.attributes.assigned_on}
            </div>

            {program.attributes.completed_at && (
              <div className="mb-2 text-end">
                Completed on
                {' '}
                {program.attributes.completed_at}
              </div>
            )}

            {!cpaProgram && !aiProgram && (
              <div className="mb-2 text-end">
                <div className="fw-light">
                  Every 2 weeks
                </div>

                <div className="fw-light">
                  {program.attributes.count_sessions}
                  {' '}
                  sessions
                </div>
              </div>
            )}

            {aiProgram && (
              <div className="mb-2 text-end">
                <div className="fw-light">
                  {program.attributes.duration}
                </div>

                <div className="fw-light">
                  {program.attributes.routine}
                </div>
              </div>
            )}

            <CoachInfo program={program} />

            <div className="mb-auto" />

            <Actions program={program} />
          </div>
        </Col>
      </Row>
    </div>
  );
}

Index.propTypes = {
  program: PropTypes.object.isRequired,
};
